export const DEVICE_PASSWORD_FORM_FIELDS = {
  devicePassword: 'devicePassword',
};
